module.exports = __webpack_public_path__ + "static/media/healthy-gray.b3eddd31.svg";